// Single source of truth for sessionStorage keys shared across services.
// Extracted in Round 3 S1 to eliminate the duplicate hardcoded constants
// in AuthService + TenantContextService (which were coupled "by-name"
// via comments — silently brittle if either key got renamed).
//
// AuthService.logout() clears BOTH keys directly so a refresh-after-logout
// cannot restore the prior operator's tenant identity, and the
// TenantContextService can't import AuthService (would be a circular
// dependency since AuthService imports TenantContextService for the
// 401 path via the interceptor). Importing this module from both is the
// clean break.
export const SESSION_AUTH_KEY = 'admin_auth';
export const SESSION_TENANT_CONTEXT_KEY = 'admin_tenant_context';
